/* 馬岱（馬超從弟） */
import { defineHero, U } from '../define.ts';

export default defineHero({
  id: 'madai', name: '馬岱', sub: '馬超從弟', faction: 'shu', role: '射手', weapon: 'bow',
  look: { weaponName: '西涼長弓', fx: '#9fe0b0', c: { plume: '#f0f2f5', armor: '#4a7a5a', pole: '#5a3a22' } },
  skills: [
    ['鷹眼', 'buff', '眼力大增 {5/10/15/20} 秒，看穿周圍草叢與隱身的敵人。', { x: { k: 'vision', self: true, dur: [5, 10, 15, 20] }, cd: 35, mp: 120 }],
    ['刺穿', 'passive', '普攻有 {15/20/25/30}% 機率額外造成 {25/35/45/55} 傷害。', { pv: { bonus: { chance: [15, 20, 25, 30], dmg: [25, 35, 45, 55] } } }],
    ['遠箭術', 'passive', '普攻射程 +{25/45/65/85}。', { pv: { range: [25, 45, 65, 85] } }],
    ['追魂箭', 'bolt', '對一名敵人射出 {1/2/3} 枝追魂箭，15 秒內持續造成傷害（共每秒 {30/55/75}）。', { x: { k: 'nuke', dot: { dps: [30, 55, 75], dur: 15 } }, aim: U(640), cd: 140, mp: [170, 200, 230] }],
  ],
});
